<div>
  <div class="modal-content">

    <div class="modal-header">
      <h3 class="modalHeader">
        Edit (User Name : {{User1.UserName}})
      </h3>
    </div>


    <form>
      <div class="modal-body">
        <div class="form-horizontal">


          <input data-val="true" data-val-number="The field Id must be a number."
            data-val-required="The Id field is required." id="user_Id" style="width:100%;max-width: 280px; "
            [(ngModel)]="User1.Id" name="Id" type="hidden" value={{User1.Id}}>

          <div class="form-group">
            <div class="col-md-2" style="color:#999;">
              <b>Email</b>
            </div>
            <div class="col-md-10">
              <input class="pagefield text-box single-line" style="width:100%;max-width: 280px; "
                [(ngModel)]="User1.UserName" name="UserName" type="text" value={{User1.UserName}} disabled>
              <span class="field-validation-valid text-danger" data-valmsg-for="UserName"
                data-valmsg-replace="true"></span>
            </div>
          </div>
          <!-- <div class="form-group">
            <div class="col-md-2" style="color:#999;">
              <b>Account Name</b>
            </div>
            <div class="col-md-10">
              <input class="pagefield text-box single-line" id="User_samAccountName" [(ngModel)]="User1.samAccountName"
                name="samAccountName" placeholder="Account Name"
                style="padding:15px;width:100%;max-width: 280px;background-color:#F9f9f9 !important;border:none;margin-bottom:8px;"
                type="text" value="" disabled>
              <span class="field-validation-valid text-danger" data-valmsg-for="samAccountName"
                data-valmsg-replace="true">
              </span>
            </div>
          </div> -->
          <br>

          <div class="form-group">
            <div class="col-md-2" style="color:#999;">
              <b>Mapped Sectors</b>
            </div>
            <div class="col-md-10">
              <select class="pagefield" style="width:100%;max-width: 280px; " multiple="multiple"
                [(ngModel)]="SectorNameList" name="SectorsMultiple" size="4">
                <option *ngFor="let sec of sectorlist" value={{sec.SectorName}}>{{sec.SectorName}}</option>

              </select>

              <span class="field-validation-valid text-danger" data-valmsg-for="user.SectorNames"
                data-valmsg-replace="true"></span>
            </div>
          </div>

          <div class="form-group">
            <div class="col-md-2" style="color:#999;">
              <b>Is Admin</b>
            </div>
            <div class="col-md-10">

              <select class="pagefield list-box tri-state" style="width:100%;max-width: 280px; "
                [(ngModel)]="User1.Roleid" name="Roleid" style="width:100px;">
                <option value="1">SuperAdmin</option>
                <option value="2">Admin</option>
                <option value="3">User</option>
              </select>
              <span class="field-validation-valid text-danger" data-valmsg-for="Roleid"
                data-valmsg-replace="true"></span>

            </div>
          </div>

          <!-- <div class="form-group">
            <div class="col-md-2" style="color:#999;">
              <b>Password</b>
            </div>
            <div class="col-md-10">
              <input class="pagefield text-box single-line" style="width:100%;max-width: 280px; " [(ngModel)]="User1.Password" name="Password" type="password" value={{User1.Password}}>
              <span class="field-validation-valid text-danger" data-valmsg-for="Password" data-valmsg-replace="true"></span>
            </div>
          </div> -->

        </div>
      </div>

      <div class="modal-footer">
        <div class="form-group">

          <button type="submit" id="approve-btn" class="btn btn-primary" (click)="confirm()">Save</button>
          <button type="button" class="btn btn-default " data-dismiss="modal" (click)="closeModal()">Cancel</button>
        </div>
      </div>
    </form>

  </div>
</div>